import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import * as mobx from 'mobx';

@Directive({ selector: '[mdAutorun]' })
export class AutorunDirective implements OnInit, OnDestroy {
  private readonly disposers: mobx.IReactionDisposer[] = [];

  @Input()
  mdAutorun?: { detach?: boolean } | '';

  /**
   * Mobx autorun wrapper that will run disposer on ngOnDestroy.
   */
  readonly autorun: typeof mobx.autorun = (
    view: (r: mobx.IReactionPublic) => any,
    opts?: mobx.IAutorunOptions,
  ): mobx.IReactionDisposer => {
    const disposer = mobx.autorun(view, opts);

    this.disposers.push(disposer);

    return disposer;
  };

  constructor(
    protected readonly templateRef: TemplateRef<any>,
    protected readonly viewContainer: ViewContainerRef,
  ) {}

  ngOnInit() {
    const view = this.viewContainer.createEmbeddedView(this.templateRef);

    if (this.mdAutorun && this.mdAutorun?.detach) {
      view.detach();
    }

    this.autorun(view.detectChanges.bind(view));
  }

  ngOnDestroy() {
    this.disposers.forEach(x => typeof x === 'function' && x());
  }
}
